import { forwardRef, useImperativeHandle } from 'react';
import { toast } from 'react-toastify';
import loadRazorpay from '../../utils/loadRazorpay';
import { razorPayKey } from '../../config/razorPay';
import TrvTo from '../../assets/images/trvto-logo.png';
import { useNavigate } from 'react-router-dom';

const Payment = forwardRef(
    // verifyPath: where to wait for the payment after Razorpay (v2 passes its own page)
    ({ options: userOptions, paymentType, paymentData, setLoading, setChangeLoading, type, verifyPath }, ref) => {
        const navigate = useNavigate();

        // Razorpay's script is loaded here, on the first payment (not on page load)
        const paymentHandler = async (userOptions) => {
            try {
                const Razorpay = await loadRazorpay();
                const rzp = new Razorpay({ ...userOptions });
                rzp.open();
            } catch (error) {
                clearTimeout(window.paymentTimeout);
                setLoading?.(false);
                toast.error('Couldn’t open the payment window. Please check your internet and try again.');
            }
        };

        useImperativeHandle(ref, () => ({
            initiatePayment: () => {
                const options = {
                    key: razorPayKey,
                    currency: 'INR',
                    amount: userOptions.amount,
                    name: userOptions.name,
                    description: userOptions.description,
                    image: TrvTo,
                    order_id: paymentData.orderId,
                    method: paymentType === 'UPI' && {
                        upi: true,
                        card: false,
                        netbanking: false,
                        wallet: false,
                        paylater: false,
                        emi: false
                    },
                    notes: {
                        type: type
                    },
                    handler: async function () {
                        // Success handler (optional)
                        setLoading(true);
                        clearTimeout(window.paymentTimeout);
                        const currentPath = window.location.pathname;
                        if (verifyPath) {
                            navigate(verifyPath, { replace: true });
                        } else if (currentPath !== '/booking-confirmation') {
                            navigate('/payment-verification', {
                                state: {
                                    type: type
                                }
                            });
                        }
                    },

                    modal: {
                        ondismiss: function () {
                            // User closed payment manually
                            clearTimeout(window.paymentTimeout);
                        }
                    },

                    redirect: true,

                    prefill: {
                        name: userOptions.prefill.name,
                        email: userOptions.prefill.email,
                        contact: userOptions.prefill.contact
                    }
                };

                paymentHandler(options);
            }
        }));

        // useEffect(() => {
        //     const onFocus = () => {
        //         const currentPath = window.location.pathname;
        //         if (currentPath !== '/booking-confirmation') {
        //             navigate('/payment-verification');
        //         }
        //     };

        //     window.addEventListener('focus', onFocus);

        //     return () => {
        //         window.removeEventListener('focus', onFocus);
        //     };
        // }, [navigate]);

        return null;
    }
);

export default Payment;
